export const authState = {
  isAuthenticated: false,
  user: null
}